module.exports = __webpack_public_path__ + "img/promobox_01m.a43beebc.svg";